import { take, call, put} from 'redux-saga/effects';
import {
	fetchConsigneeList,
	failFetchConsigneeList,
	setConsigneeListData,
	updateConsigneeFlag,
	failUpdateConsigneeFlag,
	successUpdateConsigneeFlag,
	getPdfItemsConsignee,
	failGetPdfItemsConsignee,
	setPdfItemsConsignee,
	undoConsigneeFlag,
	failUndoConsigneeFlag,
	successUndoConsigneeFlag
} from '../actions';
import superFetch from '../modules/superFetch';
import {getApiUrl} from "./index";

export function* handleFetchConsigneeList() {
	while (true) {
		const action = yield take(`${fetchConsigneeList}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'consignee-list/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failFetchConsigneeList({err:msg}));
			continue;
		}
		yield put(setConsigneeListData(Object.assign({}, payload, {})));
	}
}

export function* handleGetPdfConsignee() {
	while (true) {
		const action = yield take(`${getPdfItemsConsignee}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'get-pdf-consignee/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetPdfItemsConsignee({err:msg}));
			continue;
		}
		yield put(setPdfItemsConsignee(Object.assign({}, payload, {})));
	}
}

export function* handleUpdateConsigneeFlag() {
	while (true) {
		const action = yield take(`${updateConsigneeFlag}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'update-consignee-flag/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failUpdateConsigneeFlag({err:msg}));
			continue;
		}
		yield put(successUpdateConsigneeFlag(Object.assign({}, payload, {})));
	}
}

export function* handleUndoConsigneeFlag() {
	while (true) {
		const action = yield take(`${undoConsigneeFlag}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'undo-consignee-flag/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failUndoConsigneeFlag({err:msg}));
			continue;
		}
		yield put(successUndoConsigneeFlag(Object.assign({}, payload, {})));
	}
}


// WEBPACK FOOTER //
// ./src/sagas/consignee-list.js